import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import moment from "moment";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import scheduleMods from "data/schedule-mods";
import storeTravelChargeTypes from "data/store-travel-charge-types";
import getColumnWidth from "helpers/getColumnWidthReactTable";
import UserTypes from "components/auth/user-types";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";
import {
    closeCustomModal,
    openCustomModal
} from "components/custom/modals";

import {
    setLoading,
    fetchScheduleListPaged,
    clearScheduleList,
    setScheduleActivate,
    setScheduleDeactivate,
    deleteScheduleActivate,
    scheduleExport,
    requestPatchSchedule,
    requestPatchScheduling,
    requestHighlightSchedule,
    requestToggleAutoTravelExclusion
} from "api/menu/schedule/actions";

import {
    requestUnSubmitSchedule
} from "api/menu/reporting/actions";

import SchedulingNewFilters from "components/menu/scheduling/filter/new-filters";
import ServiceConfirmationCell from "components/menu/schedule/service-confirmation-cell";
import ListButtons from "components/menu/scheduling/list-buttons";
import OrderEntry from "../order-entry";

const ServiceReport = React.lazy(() =>
    import("components/menu/reporting/service-report"));
const SelectMerchandisers = React.lazy(() =>
    import("components/menu/scheduling/modals/select-merchandisers"));
const SelectDates = React.lazy(() =>
    import("components/menu/scheduling/modals/select-dates"));
const SelectAccountManager = React.lazy(() =>
    import("components/menu/scheduling/modals/select-account-manager"));
const SelectConsumerGroup = React.lazy(() =>
    import("components/menu/scheduling/modals/select-consumer-group"));
const SelectTimeLimit = React.lazy(() =>
    import("components/menu/scheduling/modals/select-time-limit"));
const SelectTrait = React.lazy(() =>
    import("components/menu/scheduling/modals/select-trait"));
const SelectServiceType = React.lazy(() =>
    import("components/menu/scheduling/modals/select-service-type"));
// const SelectPayRate = React.lazy(() =>
//     import("components/menu/scheduling/modals/select-pay-rate"));
const EmailBlasterMain = React.lazy(() =>
    import("components/menu/email-blaster/main"));

class SchedulingList extends React.Component {
    dateFormat = "YYYY-MM-DD";
    dateTimeFormat="YYYY-MM-DD hh:mm A"
    modalObj = false;

    constructor(props) {
        super(props);

        this.state = {
            tableState: {},
            page: 0,
            scheduleList: [],

            activeFilters: {
                earliestDate: moment().startOf("month").format("YYYY-MM-DD"),
                latestDate: moment().endOf("month").format("YYYY-MM-DD"),
                mode: {
                    label: scheduleMods[this.props.match.params.mode].title,
                    value: scheduleMods[this.props.match.params.mode].value
                }
            },

            requestParams: {}
        };

        this.reactTable = React.createRef();

        this.filterResult = this.filterResult.bind(this);
        this.handleFilterCallback = this.handleFilterCallback.bind(this);
        this.searchByFilters = this.searchByFilters.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        this.getColumns = this.getColumns.bind(this);
        this.activateSchedules = this.activateSchedules.bind(this);
        this.deactivateSchedules = this.deactivateSchedules.bind(this);
        this.deleteSchedules = this.deleteSchedules.bind(this);
        this.unSubmitSchedules = this.unSubmitSchedules.bind(this);
        this.exportSchedules = this.exportSchedules.bind(this);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSortedChange = this.handleSortedChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.onTableViewChange = this.onTableViewChange.bind(this);
        this.handleUpdateSingle = this.handleUpdateSingle.bind(this);
        this.handleUpdateBatch = this.handleUpdateBatch.bind(this);
        this.handleHighlightSchedule = this.handleHighlightSchedule.bind(this);
        this.isEditableField = this.isEditableField.bind(this);

        this.selectMerchandiser = this.selectMerchandiser.bind(this);
        this.selectAccountManager = this.selectAccountManager.bind(this);
        this.selectDates = this.selectDates.bind(this);
        this.selectConsumerGroup = this.selectConsumerGroup.bind(this);
        this.selectTimeLimit = this.selectTimeLimit.bind(this);
        this.selectTrait = this.selectTrait.bind(this);
        this.selectServiceType = this.selectServiceType.bind(this);
        // this.selectPayRate = this.selectPayRate.bind(this);

        this.onServiceCreateSuccess = this.onServiceCreateSuccess.bind(this);
        this.handleEmailBlaster = this.handleEmailBlaster.bind(this);
    }

    componentDidMount() {
        this.handleTableChange({
            page: 0,
            pageSize: 20,
            sorted: [
                {
                    id: "earliestDate",
                    desc: true
                }
            ]
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            scheduleList: nextProps.scheduleList
        }, this.onTableViewChange);
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.scheduleList, this.props.scheduleList)) {
            this.setState({
                scheduleList: this.props.scheduleList
            });
        }
    }

    componentWillUnmount () {
        this.props.clearScheduleList();
    }

    handleUpdateSingle = (serviceId, fieldName, fieldValue, modalObj, successMessage) => {
        this.props.requestPatchScheduling(serviceId, {
            [fieldName]: fieldValue
        }, () => {
            this.searchByFilters();
            toast(successMessage, {
                type: toast.TYPE.SUCCESS,
            });
            this.props.closeCustomModal(modalObj);
        });
    };

    filterResult = (list, activeFilters) => list.filter((item) => {
        if (activeFilters.jobNumber && item.jobNumber !== activeFilters.jobNumber) {
            return false;
        }

        return !(activeFilters.merchandiser && item.merchandiser !== activeFilters.merchandiser);
    });

    handleFilterCallback = (filterKey, value, isArray, callback = false) => {
        const activeFilters = Object.assign({}, this.state.activeFilters);
        activeFilters[filterKey] = value;

        this.setState({
            activeFilters
        }, () => {
            if (filterKey === "mode") {
                this.props.history.push(`/schedules/maintenance/${value.value}`);
                this.checkCanSearch(activeFilters, this.searchByFilters);
            } else if (typeof callback === "function") {
                callback();
            }
        });
    };

    checkCanSearch = (activeFilters, callback) => {
        if (activeFilters.mode) {
             if (activeFilters.mode.value === scheduleMods.Open.value) {
                if (
                    activeFilters.earliestDate !== null &&
                    activeFilters.latestDate !== null
                ) {
                    callback();
                }
            } else {
                callback();
            }
        }
    };

    resetFilters(callback = false) {
        this.setState({
            activeFilters: {}
        }, () => {
            if (typeof callback === "function") {
                callback();
            } else {
                this.searchByFilters();
            }
        });
    }

    searchByFilters() {
        this.checkCanSearch(this.state.activeFilters, () => {
            this.handleTableChange(this.state.tableState);
        });
    }

    handleTableChange(tableState) {
        const {
            activeFilters
        } = this.state;
        const requestParams = {
            pageNumber: tableState.page,
            pageSize: tableState.pageSize,
            sortOptions: null
        };

        // sorts
        if (tableState.sorted.length) {
            requestParams.sortOptions = {};
            tableState.sorted.forEach(item => {
                requestParams.sortOptions[item.id] = item.desc;
            });
        }

        // filters
        const notNeedFloatArr = ["traits", "exceptions", "mode", "category", "serviceConfirmation"];
        Object.keys(activeFilters).forEach((key) => {
            const parseFloatValue = notNeedFloatArr.indexOf(key) === -1;
            requestParams[key] = null;
            if (key === "serviceConfirmation") {
                requestParams[key] = activeFilters[key];
            } else if (activeFilters[key] !== null && typeof activeFilters[key] === "string") {
                requestParams[key] = activeFilters[key];
            } else if (activeFilters[key] !== null && activeFilters[key].value) {
                requestParams[key] = activeFilters[key].value;
                if (parseFloatValue) {
                    requestParams[key] = parseFloat(requestParams[key]);
                }
            } else if (Array.isArray(activeFilters[key]) && activeFilters[key].length) {
                requestParams[key] = activeFilters[key].map(item => {
                    if (parseFloatValue) {
                        return parseFloat(item.value);
                    }
                    return item.value;
                });
            }
        });

        this.setState({
            requestParams,
            page: tableState.page,
            tableState: {
                page: tableState.page,
                pageSize: tableState.pageSize,
                sorted: tableState.sorted,
            },
        });

        this.props.fetchScheduleListPaged(requestParams);
    }

    handlePageChange = (pageIndex) => {
        const requestParams = Object.assign({}, this.state.requestParams);
        const tableState = Object.assign({}, this.state.tableState);
        requestParams.pageNumber = pageIndex + 1;
        tableState.page = pageIndex;
        this.setState({
            requestParams,
            tableState
        }, () => {
            this.handleTableChange(tableState);
        });
    };

    handleSortedChange = (sorted) => {
        this.handleTableChange({
            page: this.state.tableState.page,
            pageSize: this.state.tableState.pageSize,
            sorted
        });
    };

    handlePageSizeChange = (pageSize) => {
        this.handleTableChange({
            page: this.state.tableState.page,
            pageSize,
            sorted: this.state.tableState.sorted
        });
    };

    onTableViewChange = () => {
        const current = this.reactTable.current;
        if (current) {
            const scheduleList = current
                .getResolvedState()
                .sortedData.map(item => item._original);
            this.setState({ scheduleList });
        }
    };

    getColumns = () => {
        const {
            userRole
        } = this.props;
        const {
            mode
        } = this.props.match.params;
        const {
            scheduleList,
        } = this.state;

        // const classNameFlexCenter = "d-flex justify-content-center align-items-center";
        const classNameFlexCenter = "";

        let result = [];

        if (userRole.includes(UserTypes.admin) || userRole.includes(UserTypes.accountManager) || userRole.includes(UserTypes.supervisor)) {
            result.push({
                Header: (
                    <div className="d-flex justify-content-center align-items-center">
                        <FontAwesomeIcon
                            icon="cog"
                            title="Actions"
                        />
                    </div>
                ),
                id: "actions",
                Cell: ({ original }) => (
                    <div className="">
                        <Dropdown>
                            <Dropdown.Toggle variant="info" size="sm" />

                            <Dropdown.Menu
                                style={{
                                    top: 30,
                                    left: 0,
                                    zIndex: 1,
                                    transform: "none"
                                }}
                            >
                                <Dropdown.Item onClick={() => this.viewReport(original.serviceId)}>
                                    Show/Enter Report
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => this.viewOrders(original.serviceId)}>
                                    Show Order(s)
                                </Dropdown.Item>
                                {userRole.includes(UserTypes.admin) ?
                                <Dropdown.Item onClick={() => {
                                    if (original.isActivated) {
                                        this.deactivateSchedules(original.serviceId);
                                    } else {
                                        this.activateSchedules(original.serviceId);
                                    }
                                }}>
                                    {original.isActivated ? "Deactivate" : "Activate"}
                                </Dropdown.Item>
                                : null}
                                { (userRole.includes(UserTypes.admin) ||
                                  userRole.includes(UserTypes.accountManager)) &&
                                  original.isSubmitted ?
                                    <Dropdown.Item
                                        onClick={() => this.unSubmitSchedules(original.serviceId)}
                                    >
                                        UnSubmit
                                    </Dropdown.Item>
                                : null }

                                {userRole.includes(UserTypes.admin) ?
                                <Dropdown.Item
                                    onClick={() => this.deleteSchedules(original.serviceId)}>
                                    Delete
                                </Dropdown.Item>
                                : null}

                                {this.props.match.params.mode === scheduleMods.NotActivated.value
                                && userRole.includes(UserTypes.admin) ?
                                <Dropdown.Item
                                    onClick={() =>
                                        this.handleHighlightSchedule(original.serviceId)}
                                >
                                    Highlight
                                </Dropdown.Item>
                                : null}

                                {(userRole.includes(UserTypes.admin)
                                  || userRole.includes(UserTypes.accountManager)
                                  || userRole.includes(UserTypes.supervisor)) ?
                                    <Dropdown.Item
                                        onClick={() => this.toggleAutoTravelExclusion(original.serviceId, !original.excludeFromAutoTravel)}
                                    >
                                        {original.excludeFromAutoTravel ? "Include in Auto Travel" : "Exclude from Auto Travel"}
                                    </Dropdown.Item>
                                : null}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                ),
                style: {
                    overflow: "initial"
                },
                width: 30,
                className: classNameFlexCenter,
            });
        }

        result.push({
            Header: "Merchandiser",
            // accessor: "merchandiser",
            id: "merchandiser",
            width: 285,
            accessor: original => original.merchandiser,
            Cell: ({ original }) => (
                <div className="w-100 d-flex justify-content-between">
                    <div>
                        {!this.isEditableField("merchandiserId") ||
                        <Button
                            size="sm"
                            onClick={() => this.selectMerchandiser(
                                original.serviceId,
                                original
                            )}
                            className="mr-1 p-1"
                        >
                            <FontAwesomeIcon icon="pen" title="Edit"/>
                        </Button>
                        }

                        {original.merchandiser}

                    </div>

                    <div>
                        {original.merchandiserAvailability.status  !== "Available" ?
                            <FontAwesomeIcon
                                icon="info-circle"
                                size="lg"
                                data-tip
                                data-for={`worker-icon-${original.merchandiserId}`}
                                className="ml-2 mr-2"
                            />
                            : null}

                        {original.merchandiserAvailability.details ?
                            <ReactTooltip id={`worker-icon-${original.merchandiserId}`} effect="float">
                                <div className="text-left">
                                    <div className="border-bottom font-weight-bold">
                                        {original.merchandiserAvailability.status}
                                    </div>
                                    {original.merchandiserAvailability.details
                                        ? original.merchandiserAvailability.details
                                            .map((item, key) =>
                                                <div key={key}>
                                                    {item}
                                                </div>)
                                        : null
                                    }
                                </div>
                            </ReactTooltip>
                            : null}

                        {!original.isTemporary ||
                            <FontAwesomeIcon
                                icon="hourglass-half"
                                title="Temporary Assignment"
                                className="mr-2 ml-2"
                            />
                        }
                    </div>
                </div>
            ),
            getProps: (state, rowInfo) => ({
                className: rowInfo && rowInfo.original && rowInfo.original.employeeAssignedIdIsUpdated ? "m-0 schedule-updated" : ""
            }),
        });

        if (userRole.includes(UserTypes.admin) || userRole.includes(UserTypes.accountManager)) {
            result.push({
                Header: "Cat.",
                accessor: "category",
                id: "category",
                width: 50
            });

            result.push({
                Header: "Account Manager",
                accessor: "accountManager",
                id: "accountManager",
                width: 180,
                Cell: ({ original }) => (
                    <div className="mr-1">
                        {!this.isEditableField("accountManager") ||
                            <Button
                                size="sm"
                                onClick={() => this.selectAccountManager(
                                    original.serviceId,
                                    original.acctManagerId
                                )}
                                className="mr-1 p-1"
                            >
                                <FontAwesomeIcon icon="pen" title="Edit"/>
                            </Button>
                        }
                        {original.accountManager}
                    </div>
                ),
            });
        }

        result.push({
            Header: "Confirmation",
            id: "confirmation",
            className: classNameFlexCenter,
            width: 120,
            Cell: ({ original }) => (
                <ServiceConfirmationCell original={original} />
            ),
        });
        result.push({
            Header: "Earliest",
            id: "earliestDate",
            className: classNameFlexCenter,
            width: 100,
            getProps: (state, rowInfo) => ({
                className: rowInfo && rowInfo.original && rowInfo.original.earliestDateIsUpdated ? "m-0 schedule-updated" : ""
            }),
            Cell: ({ original }) => (
                <div className="mr-1">
                    {!this.isEditableField("earliestDate") ||
                        <Button
                            size="sm"
                            onClick={() => this.selectDates(
                                original.serviceId,
                                "Earliest Date",
                                "earliestDate",
                                original.earliestDate
                            )}
                            className="mr-1 p-1"
                        >
                            <FontAwesomeIcon icon="pen" title="Edit"/>
                        </Button>
                    }
                    {moment(original.earliestDate).format(this.dateFormat)}
                </div>
            ),
        });
        result.push({
            Header: "Latest",
            id: "latestDate",
            className: classNameFlexCenter,
            width: 100,
            getProps: (state, rowInfo) => ({
                className: rowInfo && rowInfo.original && rowInfo.original.latestDateIsUpdated ? "m-0 schedule-updated" : ""
            }),
            Cell: ({ original }) => (
                <div className="mr-1">
                    {!this.isEditableField("latestDate") ||
                    <Button
                        size="sm"
                        onClick={() => this.selectDates(
                            original.serviceId,
                            "Latest Date",
                            "latestDate",
                            original.latestDate
                        )}
                        className="mr-1 p-1"
                    >
                        <FontAwesomeIcon icon="pen" title="Edit"/>
                    </Button>
                    }
                    {moment(original.latestDate).format(this.dateFormat)}
                </div>
            ),
        });
        result.push({
            Header: "Retailer",
            accessor: "retailerName",
            id: "retailerName",
            width: 70
        });
        result.push({
            Header: "Store #",
            accessor: "storeNumber",
            id: "storeNumber",
            width: 80,
            Cell: ({ original }) => {
                const hasExclusion = original.excludeFromAutoTravel || original.employeeExcludeFromAutoTravel || original.storeExcludeFromAutoTravel;
                const exclusionSources = [];
                if (original.excludeFromAutoTravel) exclusionSources.push('service');
                if (original.storeExcludeFromAutoTravel) exclusionSources.push('store');
                if (original.employeeExcludeFromAutoTravel) exclusionSources.push('employee');
                const exclusionTooltip = `Exclusion by ${exclusionSources.join(', ')}`;

                return (
                <div className="w-100 d-flex justify-content-between">
                    <span>{original.storeNumber}</span>
                    {hasExclusion ? (
                        <div className="d-flex align-items-center" data-tip data-for={`auto-travel-exclusion-${original.serviceId}`}>
                            <FontAwesomeIcon
                                icon="ban"
                                className="text-danger"
                                size="lg"
                            />
                            <ReactTooltip id={`auto-travel-exclusion-${original.serviceId}`} effect="float">
                                <span>{exclusionTooltip}</span>
                            </ReactTooltip>
                        </div>
                    ) : (
                        (original.storeIsTravelAssosiated || original.isTravelRegion)
                        ?
                        <span>
                            <FontAwesomeIcon
                                icon="car"
                                size="lg"
                                data-tip
                                data-for={`travel-charge-${original.serviceId}`}
                            />
                            <ReactTooltip id={`travel-charge-${original.serviceId}`} effect="float">
                                <div className="text-center">
                                    <div className="border-bottom font-weight-bold mb-2">
                                        Travel Charges
                                    </div>
                                    {original.storeIsTravelAssosiated ?
                                    <div>{`Store: ${storeTravelChargeTypes[original.storeTravelChargeType]} ${original.storeTravelCharge ? `$${original.storeTravelCharge}` : ""}`}</div>
                                    : null}
                                    {original.isTravelRegion
                                        ? <div>{`City: ${storeTravelChargeTypes[original.cityTravelChargeType]} ${original.cityTravelCharge ? `$${original.cityTravelCharge}` : ""}`}</div>
                                        : null}
                                </div>
                            </ReactTooltip>
                        </span>
                        : null
                    )}
                </div>
            )}
        });
        result.push({
            Header: "Name",
            accessor: "storeName",
            id: "storeName",
        });
        result.push({
            Header: "Job #",
            accessor: "jobNumber",
            id: "jobNumber",
            width: 100
        });
        result.push({
            Header: "Product",
            accessor: "productName",
            id: "productName",
        });
        result.push({
            Header: "Limit",
            accessor: "timeLimit",
            id: "timeLimit",
            getProps: (state, rowInfo) => ({
                className: rowInfo && rowInfo.original && rowInfo.original.timeLimitIsUpdated ? "m-0 schedule-updated" : ""
            }),
            Cell: ({ original }) => (
                <div className="mr-1">
                    {!this.isEditableField("timeLimit") ||
                    <Button
                        size="sm"
                        onClick={() => this.selectTimeLimit(
                            original.serviceId,
                            original.timeLimit
                        )}
                        className="mr-1 p-1"
                    >
                        <FontAwesomeIcon icon="pen" title="Edit"/>
                    </Button>
                    }
                    {original.timeLimit}
                </div>
            ),
        });
        result.push({
            Header: "Service",
            accessor: "serviceType",
            id: "serviceType",
            width: 130,
            getProps: (state, rowInfo) => ({
                className: rowInfo && rowInfo.original && rowInfo.original.serviceTypeIdIsUpdated ? "m-0 schedule-updated" : ""
            }),
            Cell: ({ original }) => (
                <div className="mr-1">
                    {!this.isEditableField("serviceType") ||
                    <Button
                        size="sm"
                        onClick={() => this.selectServiceType(
                            original.serviceId,
                            original.serviceTypeId
                        )}
                        className="mr-1 p-1"
                    >
                        <FontAwesomeIcon icon="pen" title="Edit"/>
                    </Button>
                    }
                    {original.serviceType}
                </div>
            ),
        });
        result.push({
            Header: "Trait",
            accessor: "trait",
            id: "trait",
            minWidth: 100,
            maxWidth: 200,
            Cell: ({ original }) => (
                <div className="mr-1">
                    {!this.isEditableField("trait") ||
                    <Button
                        size="sm"
                        onClick={() => this.selectTrait(original.serviceId, original.trait)}
                        className="mr-1 p-1"
                    >
                        <FontAwesomeIcon icon="pen" title="Edit"/>
                    </Button>
                    }
                    {original.trait}
                </div>
            ),
        });
        if (mode ==="Submitted"){
            result.push({
                Header: "Completed",
                accessor: "completed",
                id: "completed",
                Cell: ({ original }) => (
                    <div className="mr-1">
                        {original.completedDate ?
                            moment(original.completedDate).format(this.dateFormat)
                            : null}
                    </div>
                ),
            });

            result.push({
                Header: "Submitted",
                accessor: "submitted",
                id: "submitted",
                width: 180,
                Cell: ({ original }) => (
                    <div className="mr-1">
                        {original.dateReportSubmitted ?
                            moment(original.dateReportSubmitted).format(this.dateTimeFormat)
                            : null}
                    </div>
                ),
            });
        }
        if (userRole.includes(UserTypes.admin)) {
            result.push({
                Header: "PayRate",
                id: "payratePerHour",
                accessor: original => (original.payrateFlat > 0
                        ? original.payrateFlat
                        : original.payratePerHour
                ),
                Cell: ({ original }) => (
                    <div className="mr-1">
                        {original.payrateFlat > 0 ? `${original.payrateFlat} (flat)` : `${original.payratePerHour}/h`}
                    </div>
                ),
            });
        }

        result = result.map((value) => {
            value.headerClassName = "text-left";
            if (!value.style) {
                value.style = {};
            }
            if (value.style) {
                value.style.display = "flex";
                value.style.alignItems = "center";
                value.style.height = "100%";
            }
            let fieldName = value.id;
            if (fieldName === "merchandiser") {
                fieldName = "merchandiserId";
            }
            if (!value.width && value.id && this.isEditableField(fieldName)) {
                value.width = getColumnWidth(
                    scheduleList,
                    value.accessor,
                    value.Header
                );
            }
            return value;
        });

        return result;
    };

    toggleAutoTravelExclusion = (serviceId, exclude) => {
        this.props.requestToggleAutoTravelExclusion(serviceId, exclude, (success) => {
            if (success) {
                const newScheduleList = this.state.scheduleList.map(item => {
                    if (item.serviceId === serviceId) {
                        return { ...item, excludeFromAutoTravel: exclude };
                    }
                    return item;
                });
                this.setState({ scheduleList: newScheduleList });
            }
        });
    };

    activateSchedules = (serviceId = null) => {
        const { requestParams } = this.state;
        this.props.setLoading();
        this.props.setScheduleActivate(requestParams, serviceId);
    };

    deactivateSchedules = (serviceId = null) => {
        const { requestParams } = this.state;
        this.props.setLoading();
        this.props.setScheduleDeactivate(requestParams, serviceId);
    };

    deleteSchedules = (serviceId = false) => {
        const requestParams = Object.assign({}, this.state.requestParams);
        requestParams.startDate = requestParams.earliestDate;
        requestParams.endDate = requestParams.latestDate;
        delete requestParams.earliestDate;
        delete requestParams.latestDate;

        if (serviceId) {
            requestParams.serviceId = serviceId;
        }

        this.props.setLoading();
        this.props.deleteScheduleActivate(requestParams, () => {
            this.searchByFilters();
        });
    };

    unSubmitSchedules = (serviceId) => {
        this.props.setLoading();
        this.props.requestUnSubmitSchedule(serviceId, () => {
            this.searchByFilters();
        });
    };

    exportSchedules = (callback) => {
        const { requestParams } = this.state;
        this.props.scheduleExport(requestParams, (data) => {
            callback(data);
        });
    };

    handleUpdateBatch = (data) => {
        const { requestParams } = this.state;
        this.props.requestPatchSchedule(requestParams, data, () => {
            this.searchByFilters();
        });
    };

    handleHighlightSchedule = (serviceId = false) => {
        const requestParams = Object.assign({}, this.state.requestParams);
        requestParams.startDate = requestParams.earliestDate;
        requestParams.endDate = requestParams.latestDate;
        delete requestParams.earliestDate;
        delete requestParams.latestDate;

        if (serviceId) {
            requestParams.serviceId = serviceId;
        }

        this.props.setLoading();
        this.props.requestHighlightSchedule(requestParams, () => {
            this.searchByFilters();
        });
    };

    isEditableField = (fieldName) => {
        const { userRole } = this.props;
        const mode = this.props.match.params.mode;
        if (mode === scheduleMods.Submitted.value) {
            return false;
        }
        if (
            mode === scheduleMods.NotActivated.value &&
            (userRole.includes(UserTypes.supervisor) || userRole.includes(UserTypes.accountManager))
        ) {
            return false;
        }

        if (mode === scheduleMods.NotActivated.value && userRole.includes(UserTypes.supervisor)) {
            return false;
        }

        switch (fieldName) {
            case "merchandiserId":
            case "timeLimit":
            case "earliestDate":
            case "latestDate":
                return userRole.includes(UserTypes.admin)
                    || userRole.includes(UserTypes.accountManager)
                    || userRole.includes(UserTypes.supervisor);
            case "trait":
            case "serviceType":
            case "consumerGroup":
                return userRole.includes(UserTypes.admin)
                    || userRole.includes(UserTypes.accountManager);
            case "payrateFlat":
            case "accountManager":
                return userRole.includes(UserTypes.admin);
            default:
                return false;
        }
    };

    viewOrders = (serviceId) => {
        const modalObj = {
            id: "view-orders",
            modalSettings: {
                size: "lg",
                style: {
                    top: 20,
                    width: "calc(100% - 100px)"
                },
            },
            header: "Orders",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <OrderEntry
                        serviceId={serviceId}
                        handleClose={() => this.props.closeCustomModal(modalObj)}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    }

    viewReport = (serviceId) => {
        const modalObj = {
            id: "view-report",
            modalSettings: {
                size: "lg",
                style: {
                    top: 20,
                    width: "calc(100% - 40px)"
                },
            },
            header: `Service Report: ${serviceId}`,
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <ServiceReport
                        serviceId={serviceId}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSave={() => {
                            this.props.closeCustomModal(modalObj);
                            this.handleTableChange(this.state.tableState);
                        }}
                        onSubmit={() => {
                            this.props.closeCustomModal(modalObj);
                            this.handleTableChange(this.state.tableState);
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    selectMerchandiser = (serviceId, original) => {
        const { scheduleListOptions } = this.props;
        const modalObj = {
            id: "select-merchandiser",
            modalSettings: {
                size: "sm"
            },
            header: "Select Merchandiser",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <SelectMerchandisers
                        currentValue={original.merchandiserId}
                        original={original}
                        totalFilteredRecords={scheduleListOptions.totalFilteredRecords || 0}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSubmit={(values, applyToAll) => {
                            if (applyToAll) {
                                this.handleUpdateBatch({
                                    merchandiserId: values.value,
                                    sendBackup: values.sendBackup,
                                    sendSupply: values.sendSupply,
                                    markMerchandiserAsTemporary: values.markAsTemp,
                                });
                            } else {
                                this.props.requestPatchScheduling(serviceId, {
                                    merchandiserId: values.value,
                                    sendBackup: values.sendBackup,
                                    sendSupply: values.sendSupply,
                                    markMerchandiserAsTemporary: values.markAsTemp,
                                }, () => {
                                    this.searchByFilters();
                                    toast("Merchandiser updated successfully", {
                                        type: toast.TYPE.SUCCESS,
                                    });
                                    this.props.closeCustomModal(modalObj);
                                });
                            }
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    selectDates = (serviceId, modalName, field, currentValue) => {
        const { scheduleListOptions } = this.props;
        const modalObj = {
            id: "select-dates",
            modalSettings: {
                size: "sm"
            },
            header: modalName,
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <SelectDates
                        modalName={modalName}
                        dateKey={field}
                        currentValue={currentValue}
                        totalFilteredRecords={scheduleListOptions.totalFilteredRecords || 0}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSubmit={(value, applyToAll) => {
                            if (applyToAll) {
                                this.handleUpdateBatch({
                                    [field]: value
                                });
                            } else {
                                this.handleUpdateSingle(
                                    serviceId,
                                    field,
                                    value,
                                    modalObj,
                                    `${modalName} updated successfully`
                                );
                            }
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    selectAccountManager = (serviceId, currentValue) => {
        const { scheduleListOptions } = this.props;
        const modalObj = {
            id: "select-account-manager",
            modalSettings: {
                size: "sm"
            },
            header: "Select account manager",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <SelectAccountManager
                        currentValue={currentValue}
                        totalFilteredRecords={scheduleListOptions.totalFilteredRecords || 0}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSubmit={(option, applyToAll) => {
                            if (applyToAll) {
                                this.handleUpdateBatch({
                                    acctManagerId: option.value
                                });
                            } else {
                                this.handleUpdateSingle(
                                    serviceId,
                                    "acctManagerId",
                                    option.value,
                                    modalObj,
                                    "Account manager updated successfully"
                                );
                            }
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    selectConsumerGroup = (serviceId, currentValue) => {
        const { scheduleListOptions } = this.props;
        const modalObj = {
            id: "select-consumer-group",
            modalSettings: {
                size: "sm"
            },
            header: "Select Consumer Group",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <SelectConsumerGroup
                        currentValue={currentValue}
                        totalFilteredRecords={scheduleListOptions.totalFilteredRecords || 0}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSubmit={(option, applyToAll) => {
                            if (applyToAll) {
                                this.handleUpdateBatch({
                                    consumerGroupId: option.value
                                });
                            } else {
                                this.handleUpdateSingle(
                                    serviceId,
                                    "consumerGroupId",
                                    option.value,
                                    modalObj,
                                    "Consumer Group updated successfully"
                                );
                            }
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    selectTimeLimit = (serviceId, currentValue) => {
        const { scheduleListOptions } = this.props;
        const modalObj = {
            id: "select-time-limit",
            modalSettings: {
                size: "sm"
            },
            header: "Time Limit",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <SelectTimeLimit
                        currentValue={currentValue}
                        totalFilteredRecords={scheduleListOptions.totalFilteredRecords || 0}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSubmit={(value, applyToAll) => {
                            if (applyToAll) {
                                this.handleUpdateBatch({
                                    timeLimit: value
                                });
                            } else {
                                this.handleUpdateSingle(
                                    serviceId,
                                    "timeLimit",
                                    value,
                                    modalObj,
                                    "Time limit updated successfully"
                                );
                            }
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    selectTrait = (serviceId, currentValue) => {
        const { scheduleListOptions } = this.props;
        const modalObj = {
            id: "select-trait-limit",
            modalSettings: {
                size: "sm"
            },
            header: "Trait",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <SelectTrait
                        currentValue={currentValue || ""}
                        totalFilteredRecords={scheduleListOptions.totalFilteredRecords || 0}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSubmit={(value, applyToAll) => {
                            if (applyToAll) {
                                this.handleUpdateBatch({
                                    trait: value
                                });
                            } else {
                                this.handleUpdateSingle(
                                    serviceId,
                                    "trait",
                                    value,
                                    modalObj,
                                    "Trait updated successfully"
                                );
                            }
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    selectServiceType = (serviceId, currentValue) => {
        const { scheduleListOptions } = this.props;
        const modalObj = {
            id: "select-service-type",
            modalSettings: {
                size: "sm"
            },
            header: "Select service type",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <SelectServiceType
                        currentValue={currentValue}
                        totalFilteredRecords={scheduleListOptions.totalFilteredRecords || 0}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSubmit={(option, applyToAll) => {
                            if (applyToAll) {
                                this.handleUpdateBatch({
                                    serviceTypeId: option.value
                                });
                            } else {
                                this.handleUpdateSingle(
                                    serviceId,
                                    "serviceTypeId",
                                    option.value,
                                    modalObj,
                                    "Service type updated successfully"
                                );
                            }
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    onServiceCreateSuccess = () => {
        this.handleTableChange(this.state.tableState);
    };

    handleEmailBlaster = () => {
        const modalObj = {
            id: "email-blaster",
            modalSettings: {
                size: "lg",
                style: {
                    top: 20,
                    width: "calc(100% - 40px)"
                },
            },
            header: "Email Blaster",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <div>
                        <EmailBlasterMain
                            isModal={true}
                            requestData={this.state.requestParams}
                            onCancel={() => this.props.closeCustomModal(modalObj)}
                        />
                        <div className="text-right">
                            <button
                                className="btn btn-success"
                                onClick={() => this.props.closeCustomModal(modalObj)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    render () {
        const {
            loading,
            scheduleListOptions
        } = this.props;

        const {
            scheduleList,
            activeFilters,
            page
        } = this.state;

        if (!activeFilters.mode && this.props.match.params.mode) {
            activeFilters.mode = {
                label: scheduleMods[this.props.match.params.mode].title,
                value: scheduleMods[this.props.match.params.mode].value
            };
        }

        return (
            <div className="dashboard">
                <SchedulingNewFilters
                    title="Schedule Maintenance"
                    titleFilteredCounts={{
                        totalFilteredRecords: scheduleListOptions.totalFilteredRecords || 0,
                        totalRecords: scheduleListOptions.pageSize || 0
                    }}
                    filters={scheduleListOptions.metadata}
                    activeFilters={activeFilters}
                    filterCallback={this.handleFilterCallback}
                    onSearch={this.searchByFilters}
                    onReset={this.resetFilters}
                    onCheckCanSearch={this.checkCanSearch}
                />

                <ReactTable
                    data={scheduleList}
                    headerClassName="table-header"
                    columns={this.getColumns()}
                    defaultPageSize={20}
                    pageSizeOptions={[20, 50, 100, 500, 1000]}
                    pages={Math.ceil(
                        scheduleListOptions.totalFilteredRecords /
                        scheduleListOptions.pageSize
                    )}
                    page={page}
                    resizable
                    className="-striped -highlight fix-scrollbar-size schedules-table"
                    loading={loading}
                    ref={this.reactTable}
                    onFilteredChange={(filtered, column) =>
                        this.onTableViewChange(filtered, column)
                    }
                    filterable={false}
                    defaultFilterMethod={filterCaseInsensitive}
                    // onFetchData={this.handleTableChange}
                    onSortedChange={this.handleSortedChange}
                    onPageChange={this.handlePageChange}
                    onPageSizeChange={this.handlePageSizeChange}
                    handleRefreshPage={this.searchByFilters}
                    manual={true}
                    defaultSorted={[
                        {
                            id: "earliestDate",
                            desc: true
                        }
                    ]}
                    getNoDataProps = {() => ({
                        style: {
                            zIndex: 0
                        }
                    })}
                    style={{
                        height: "calc(100vh - 220px)",
                    }}
                    getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row && rowInfo.row._original) {
                            return {
                                className: rowInfo.row._original.isHighlighted ? "m-0 schedule-yellow" : ""
                            };
                        }
                        return {};
                    }}
                />

                <ListButtons
                    handleActivate={() => this.activateSchedules()}
                    handleDeactivate={() => this.deactivateSchedules()}
                    handleDelete={() => this.deleteSchedules()}
                    handleHighlight={() => this.handleHighlightSchedule()}
                    handleExport={this.exportSchedules}
                    mode={this.props.match.params.mode}
                    totalFilteredRecords={scheduleListOptions.totalFilteredRecords || 0}
                    onServiceCreateSuccess={this.onServiceCreateSuccess}
                    onEmailBlasterClick={this.handleEmailBlaster}
                />
            </div>
        );
    }
}

SchedulingList.propTypes = {
    fetchScheduleListPaged: PropTypes.func.isRequired,
    clearScheduleList: PropTypes.func.isRequired,
    scheduleList: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    user: state.auth.user,
    userRole: state.auth.user.role,
    scheduleList: state.schedule.scheduleList,
    scheduleListOptions: state.schedule.scheduleListOptions,
    loading: state.schedule.loading
});

const mapStateToDispatch = dispatch => ({
    setLoading: bindActionCreators(setLoading, dispatch),
    fetchScheduleListPaged: bindActionCreators(fetchScheduleListPaged, dispatch),
    clearScheduleList: bindActionCreators(clearScheduleList, dispatch),
    setScheduleActivate: bindActionCreators(setScheduleActivate, dispatch),
    setScheduleDeactivate: bindActionCreators(setScheduleDeactivate, dispatch),
    scheduleExport: bindActionCreators(scheduleExport, dispatch),
    deleteScheduleActivate: bindActionCreators(deleteScheduleActivate, dispatch),
    requestPatchSchedule: bindActionCreators(requestPatchSchedule, dispatch),
    requestPatchScheduling: bindActionCreators(requestPatchScheduling, dispatch),
    requestHighlightSchedule: bindActionCreators(requestHighlightSchedule, dispatch),
    requestToggleAutoTravelExclusion: bindActionCreators(requestToggleAutoTravelExclusion, dispatch),
    requestUnSubmitSchedule: bindActionCreators(requestUnSubmitSchedule, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(SchedulingList);
